module.exports = __webpack_public_path__ + "img/401.a58ae598.png";